import $ from 'jquery';
import gsap from 'gsap';
import product from '../pages/product';
import search from '../utils/search';
import drop from '../utils/drop';
import onglet from '../utils/onglet';
import initSwiper from '../utils/swiper';
import categories from '../utils/categories';
import { ensureRecaptcha } from '../utils/recaptcha';

const common = {
	$windowH: null,
	$windowW: null,
	$documentW: null,
	$windowInnerWidth: null,
	$fullHeight: null,
	$windowW_actual: null,
	activSECTION: null,
	IN_VIEW: "accueil",
	smooth: null,
	disableSECTIONS: false,
	$sections: document.querySelectorAll('._section'),
	waypoint: null,
	movePlaceSection: false,
	responsiveMode: null,
	responsiveReloadTimer: null,
	responsiveReloadLocked: false,

	init() {
		this.logConsoleBanner();
		this.forms();
		//cookies.init();
		this.deleteObj();
		this.setupNewsletter();
		this.setupFooterNewsletter();
		this.getWINDOW();
		this.initResponsiveReload();
		this.setupResizeListener();
		this.initDestinationsSwiper();
		this.setupBtnTextSlide();
		search.init();
		drop.init();
		onglet.init();
		categories.init();
		this.initRecaptchaLazyLoad();
	},

	initRecaptchaLazyLoad() {
		$(document).on('focusin.recaptcha pointerdown.recaptcha', function (e) {
			if ($(e.target).closest('form').find('.g-recaptcha').length) {
				ensureRecaptcha();
			}
		});
	},

	// Repere visuel rapide en console (bon environnement/bonne page charge)
	// + temps de chargement total, pour controler les regressions de perf
	// sans avoir a rouvrir l'onglet Network a chaque fois.
	logConsoleBanner() {
            console.log('%cOPHORUS', 'color:#895BED;font-size:72px;font-weight:900;font-family:sans-serif;letter-spacing:8px;line-height:1;');

		window.addEventListener('load', () => {
			// loadEventEnd (donc nav.duration) n'est stampe par le navigateur
			// qu'une fois le traitement de "load" termine - le lire de facon
			// synchrone dans ce handler renvoie encore 0, d'ou le setTimeout(0)
			// pour repasser apres.
			setTimeout(() => {
				const nav = performance.getEntriesByType('navigation')[0];
				const duration = Math.round(nav ? nav.duration : performance.now());
                    console.log(`%cPage done in ${duration}ms`, 'color:#fff;font-weight:700;font-size:13px;');
			}, 0);
		});
	},

	// Remplit data-name sur le <span> des ._ophorus_btn qui n'en ont pas
	// deja (certaines vues le posent a la main, cf. accueil_about.php) :
	// le SCSS du bouton (._ophorus_btn span:before, content: attr(data-name))
	// s'en sert pour dupliquer le texte et faire l'effet "texte qui remonte"
	// au survol, sans avoir a dupliquer le <span> dans chaque vue.
	setupBtnTextSlide() {
		$("._ophorus_btn > span").each(function () {
			if (!this.hasAttribute("data-name")) {
				this.setAttribute("data-name", this.textContent.trim());
			}
		});
	},

	// carousel "Explore [more] destinations" -- partage entre l'accueil
	// et les pages resultats (region, etc.) qui reutilisent le meme composant
	initDestinationsSwiper() {
		if (!document.querySelector('.__home_destinations')) {
			return;
		}

		const destinationsSwiper = initSwiper('.__home_destinations', {
			loop: false,
			slidesPerView: '3.6',
			spaceBetween: 10,
			navigation: false,
			autoplay: false,
			breakpoints: {
				0: {slidesPerView: '1.2'},
				640: {slidesPerView: '1.3'},
				768: {slidesPerView: '2.7'},
				1300: {slidesPerView: '3.8'},
				1600: {slidesPerView: '4'},
			},
		});

		// Cherche les boutons ronds au plus proche du carousel plutot que de
		// fixer en dur la classe de section de l'accueil (".__ophorus_acc_destinations") :
		// ce composant est aussi reutilise sur les pages resultats (region,
		// cf. RESULTS/results_bottom_region.php), dont le conteneur porte une
		// autre classe.
		const $host = $('.__home_destinations').closest('section');
		const prevBtn = $host.find('.__swiper_controls .__swiper_prev').get(0);
		const nextBtn = $host.find('.__swiper_controls .__swiper_next').get(0);

		if (prevBtn && nextBtn && destinationsSwiper) {
			const updateNavigationState = () => {
				prevBtn.classList.toggle('_disabled', destinationsSwiper.isBeginning);
				nextBtn.classList.toggle('_disabled', destinationsSwiper.isEnd);
			};

			prevBtn.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopPropagation();
				if (destinationsSwiper.isBeginning) {
					return;
				}
				destinationsSwiper.slidePrev();
			});

			nextBtn.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopPropagation();
				if (destinationsSwiper.isEnd) {
					return;
				}
				destinationsSwiper.slideNext();
			});

			destinationsSwiper.on('slideChange', updateNavigationState);
			destinationsSwiper.on('resize', updateNavigationState);
			destinationsSwiper.on('update', updateNavigationState);
			updateNavigationState();
		}

		$(".__home_destinations").removeClass('_hide');
	},
	initResponsiveReload() {
		const BREAKPOINT = 991;

		const getMode = () => {
			return window.innerWidth <= BREAKPOINT ? 'mobile' : 'desktop';
		};

		this.responsiveMode = getMode();

		const handleResize = () => {
			clearTimeout(this.responsiveReloadTimer);

			this.responsiveReloadTimer = setTimeout(() => {
				if (this.responsiveReloadLocked) return;

				const newMode = getMode();

				if (newMode !== this.responsiveMode) {
					this.responsiveReloadLocked = true;
					window.location.reload();
				}
			}, 300);
		};

		window.addEventListener('resize', handleResize);
		window.addEventListener('orientationchange', handleResize);
	},
	setupNewsletter() {
		const newsletterElement = document.querySelector(".__ophorus_newsletter");

		if (newsletterElement) {
			this.newsletter_height = newsletterElement.offsetHeight;
			this.newsletter_pos = newsletterElement.getBoundingClientRect();

			document.addEventListener("click", (event) => {
				if (event.target.matches(".__close_newsletter")) {
					gsap.to(".__ophorus_newsletter", {
						height: 0,
						duration: 0.6,
						ease: "Cubic.easeOut"
					});
				}

				if (event.target.matches("._open_newsletter")) {
					gsap.to(".__ophorus_newsletter", {
						height: "auto",
						duration: 0.6,
						onComplete: () => {
							gsap.to(window, {
								scrollTo: {y: this.newsletter_pos.top - 70},
								duration: 1.2,
								ease: "Expo.easeOut"
							});
						}
					});
				}
			});
		}
	},

	// Formulaire d'inscription newsletter du nouveau bloc footer (cf.
	// TEMPLATES/footer_content.php) - present sur toutes les pages, donc ici
	// plutot que dans un module pages/*.js dedie a une seule page.
	setupFooterNewsletter() {
		$(document).on("submit", "#__footer_newsletter_form", (event) => {
			event.preventDefault();

			const $form = $(event.currentTarget);
			const $msg = $form.siblings(".__footer_newsletter_msg");
			const $btn = $form.find("button[type=submit]");
			const email = $form.find("input[name=newsletter_email]").val();

			$btn.prop("disabled", true);
			$msg.removeClass("_error").text("");

			$.ajax({
				url: `${_SITE_URL}newsletter-subscribe`,
				type: "post",
				dataType: "json",
				data: {newsletter_email: email, _btn: "_newsletter"},
				success: (response) => {
					$msg.toggleClass("_error", !response.success).text(response.message);
					if (response.success) {
						$form.trigger("reset");
					}
				},
				error: () => {
					$msg.addClass("_error").text("Something went wrong, please try again.");
				},
				complete: () => {
					$btn.prop("disabled", false);
				}
			});
		});
	},

	getWINDOW() {
		this.$windowH = window.innerHeight;
		this.$windowW = window.innerWidth;
		this.$documentW = document.documentElement.clientWidth;
		this.$fullHeight = Math.max(
			document.body.scrollHeight,
			document.documentElement.scrollHeight,
			document.body.offsetHeight,
			document.documentElement.offsetHeight,
			document.body.clientHeight,
			document.documentElement.clientHeight
		);

		if (this.$windowW_actual !== this.$windowW) {
			this.$windowW_actual = this.$windowW;
		}
	},

	setupResizeListener() {
		window.addEventListener("resize", () => {
			this.getWINDOW();
		});
	},

	forms() {
		document.addEventListener("click", (e) => {
			const btn = e.target.closest("button._quantity");
			if (!btn) return;

			const isExtra = btn.classList.contains("_extra");
			const isBooking = btn.classList.contains("_book");
			const isFromExtras = btn.classList.contains("_extra_from_product");

			const op = btn.dataset.op;
			const input = document.querySelector(`input[data-op="${op}"]`);
			if (!input) return;

			let value = parseInt(input.value, 10) || 0;
			const min = isExtra ? 0 : product.minQuantity;
			const max = product.maxQuantity;

			if (btn.classList.contains("_plus")) {
				if (!isExtra && document.querySelector("input[name=force_min]") && value === 0) {
					value = min;
				} else if (value < max) {
					value++;
				}
			} else {
				if (!isExtra && document.querySelector("input[name=force_min]") && value === min) {
					value = 0;
				} else {
					value = Math.max(0, value - 1);
				}
			}

			input.value = value;


			// MAJ bouton "-"
			const minusBtn = document.querySelector(`button._minus[data-op="${op}"]`);
			if (minusBtn) {
				if (value <= (document.querySelector("input[name=force_min_pers]") ? min : 0)) {
					minusBtn.classList.add("_disabled");
					minusBtn.setAttribute("disabled", "disabled");
				} else {
					minusBtn.classList.remove("_disabled");
					minusBtn.removeAttribute("disabled");
				}
			}

			// MAJ du prix ou extras
			if (isBooking) {
				product.getPrice();
			}
			if (isFromExtras) {
				product.checkExtras();
			}
		});
	},

	deleteObj() {
		if (window.navigatorUtils.checkMobile()) {
			const mapColumn = document.querySelector("._col_contain_map");
			if (mapColumn) mapColumn.remove();
		}
	}
};

// Exportation pour l'utiliser dans `main.js`
export default common;
